import { useMemo } from 'react';

import { useUniquePurchasedItems } from 'state/auth/hooks/use-unique-purchased-items';
import { isCartEntryInMenu } from 'utils/cart';

export const useRecentItemsAvailable = () => {
  const { uniquePurchasedItems } = useUniquePurchasedItems();
  const hasUniquePurchasedItems = useMemo(
    () =>
      Array.isArray(uniquePurchasedItems) &&
      uniquePurchasedItems.length > 0 &&
      uniquePurchasedItems.some(isCartEntryInMenu),
    [uniquePurchasedItems]
  );
  return hasUniquePurchasedItems;
};
